import React from 'react';
import { ButtonPrimary as ButtonPrimaryStyle } from './styles';

const ButtonPrimary = ({ text, onClick, className, disabled, style, type = "submit" }) => {
    return (
        <ButtonPrimaryStyle disabled={disabled} type={type} onClick={onClick} className={className} style={style}>
            {text}
        </ButtonPrimaryStyle>
    );
};

export default ButtonPrimary;
